<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="审核状态：">
        <el-select v-model="query.state" placeholder="请选择" clearable size="small">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="审核通过" :value="1"></el-option>
          <el-option label="驳回申请" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请人身份：">
        <el-select v-model="query.levelName" placeholder="请选择" clearable size="small">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="体验班" value="体验班"></el-option>
          <el-option label="研修班" value="研修班"></el-option>
          <el-option label="普通用户" value="普通用户"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交来源：">
        <el-select v-model="query.dataSource" placeholder="请选择" clearable size="small">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="app业务员添加" :value="1"></el-option>
          <el-option label="管理员添加" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请内容：">
        <el-select v-model="query.registrationType" placeholder="请选择" clearable size="small">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="普通人员升级研修班" :value="1"></el-option>
          <el-option label="普通人员升级体验班" :value="2"></el-option>
          <el-option label="体验班升级研修班" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="付款时间：">
        <el-date-picker v-model="payDateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import customerRegistrationApi from '@/api/cust/customerRegistration'
import { filterEmpty } from '@/utils'
export default {
  data() {
    return {
      dateTime: [],
      payDateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        applyLevelName: undefined,
        dataSource: undefined,
        registrationType: undefined,
      },
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      let params =  JSON.parse(JSON.stringify(this.query))
      if(this.dateTime && this.dateTime.length > 0) params.timeType = 0
      params.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      params.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      params.payTimeStart = this.payDateTime && this.payDateTime.length > 0 ? this.payDateTime[0] : undefined
      params.payTimeEnd = this.payDateTime && this.payDateTime.length > 0 ? this.payDateTime[1] : undefined
      if (!params.dataSource) {
        params.dataSource = '1,2'
      }
      return this.$common.confirm('是否确认导出')
        .then(() => customerRegistrationApi.registrationExport(filterEmpty(params))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>